import asyncRetry from "async-retry";
const RETRY_OPTIONS = {
  // retries means N tries after the first time, for a total of N + 1 attempts
  retries: 4,
  minTimeout: 200
};
async function retry(resolver, options = {}) {
  return asyncRetry(resolver, { ...RETRY_OPTIONS, ...options });
}
export {
  retry as r
};
//# sourceMappingURL=retry-CXjXn1MV.js.map
